import React from "react";
import {Row, Col} from "react-bootstrap";
import {background, logo as logoStyle, logoContainer, bar} from "../styles/index.module.css";
import logoImg from "../content/logo-main.png";

export function Header() {
    return <Row className={background}>
	<Col lg={7}>

	</Col>
	<Col lg={5} className={logoContainer}>
	<a href="/">  <Logo></Logo></a>
	  
	</Col>
	</Row>;
}

export function Logo() {
    return <img src={logoImg} alt="Logo" className={logoStyle}/>;
}
